import React, { useState } from 'react'
import AddDocument from './AddDocument'
import AddDocName from './AddDocName'

const TabStyle = {
    width: '50%',
    textAlign: 'center',
    cursor: 'pointer',
    // borderBottom:'3px solid rgba(0,0,0,.25)'
    background: 'rgb(219, 233, 255)',
    padding: '5px',
}

const ActiveTabStyle = {
    width: '50%',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#fff',
    // borderBottom:'3px solid #267dff'
    background: 'rgb(6, 66, 84)',
    padding: '5px',
}

export default function Main({editData}) {
    const [tab, setTab] = useState("addDocConfigurations");
    const [newEditData,setNewEditData]=useState(editData || {})
    const handleTabs = (type) => {
        setTab(type)
        setNewEditData({})
    }

    return (
        <>
            <div className="tabss" style={{ display: 'flex', width: '100%', marginTop: '15px' }}>
                <div className="subtabss" style={tab === "addDocConfigurations" ? ActiveTabStyle : TabStyle} onClick={(e) => handleTabs("addDocConfigurations")}>
                    <h4>Configure Documents</h4>
                </div>
                <div className="subtabss" style={tab === "documentName" ? ActiveTabStyle : TabStyle} onClick={(e) => handleTabs("documentName")}>
                    <h4>Add Document Name</h4>
                </div>
            </div>

            {
                tab === "addDocConfigurations" ?
                    <AddDocument Editdata={newEditData}/>
                    : ''}

            {
                tab === "documentName" ?
                    <AddDocName />
                    : ''}


        </>
    )
}
